module.exports = __webpack_public_path__ + "static/media/puzzle_icon.1b8140a9.png";